import { Box, Button, Card, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "./utils";

const UserVerify = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/");
  };
  return (
    <Grid container sx={{ height: "100vh" }}>
      {/* Left Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          backgroundColor: "#2C3E50",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            maxWidth: 300,
            borderRadius: 4,
            boxShadow: 3,
            backgroundColor: "#34495E",
          }}
        >
          <Logo
            width={"100%"}
            height={"100%"}
            style={{ marginRight: 8 }} // Add spacing between logo and text
          />
        </Card>
      </Grid>

      {/* Right Section */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 3,
        }}
      >
        <Box sx={{ textAlign: "center", maxWidth: 400, width: "100%" }}>
          <Typography
            variant="body1"
            sx={{ marginBottom: 3, color: "text.secondary" }}
          >
            Welcome!Report an issue by submitting pictures and/or videos. Any
            misuse or misconduct is punishable by law. Thank you for being a
            responsible citizen
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleContinue}
            sx={{
              backgroundColor: "#3F6955",
              "&:hover": {
                backgroundColor: "#2C5B44",
              },
            }}
          >
            Start Capture
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserVerify;
